/**
 * Denna blir 2 kolumner på stor skärm
 */

import { cn } from "helpers/classNames";
import { ReactNode } from "react";

interface Props extends React.ComponentPropsWithoutRef<"table"> {
  children?: ReactNode;
}

export const DetailsList = ({ children, className, ...rest }: Props) => (
  <table
    className={cn("w-full", className)}
    // className={cn("[&_tr:nth-child(odd)]:bg-gray-25 w-full", className)}
    {...rest}
  >
    <tbody className="divide-y divide-gray-100">{children}</tbody>
  </table>
);

interface LabelProps extends React.ComponentPropsWithoutRef<"td"> {
  children?: ReactNode;
}

export const Label = ({ children, className, ...rest }: LabelProps) => (
  <td
    className={cn(
      "mb-1 w-1 whitespace-nowrap text-base font-normal text-gray-700 sm:py-2 sm:pl-6 sm:text-left sm:text-sm sm:text-gray-900",
      // "font-base mb-1 text-base text-gray-950 sm:text-right sm:text-sm",
      className,
    )}
    {...rest}
  >
    {children}
  </td>
);

interface ValueProps extends React.ComponentPropsWithoutRef<"td"> {
  children?: ReactNode;
}

export const Value = ({ children, className, ...rest }: ValueProps) => (
  <td
    className={cn(
      "text-base font-medium text-gray-950 sm:py-2 sm:pb-0 sm:pl-4 sm:text-sm",
      className,
    )}
    {...rest}
  >
    {/* <dd className={cn("text-base text-gray-700 sm:text-sm", className)} {...rest}> */}
    {children}
  </td>
);

interface ItemProps extends React.ComponentPropsWithoutRef<"tr"> {
  children?: ReactNode;
}
export const Item = ({ children, className, ...rest }: ItemProps) => (
  <tr
    className={cn(
      "grid grid-cols-1 gap-y-0 py-3 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-0 sm:py-2",
      className,
    )}
    {...rest}
  >
    {children}
  </tr>
);
